import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { IPurchaserRequest, IPurchaserResponse } from '../models/purchasers/purchaser.model';

@Injectable({
  providedIn: 'root',
})
export class PurchaserApiService {
  headers = { 'content-type': 'application/json' };

  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/purchasers`;
  }

  constructor(private http: HttpClient) {}

  getPagedPurchasers(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IPurchaserResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IPurchaserResponse[]>>(this.url, { params });
  }

  getAllPurchasers(departmentId?: string): Observable<IPurchaserResponse[]> {
    let url = `${this.url}`;
    if (departmentId) {
      url = `${url}/List?DepartmentId=${departmentId}`;
    }
    return this.http.get<IPurchaserResponse[]>(url);
  }

  getPurchaserById(id: string): Observable<IPurchaserResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<IPurchaserResponse>(url);
  }

  createPurchaser(purchaser: IPurchaserRequest): Observable<IPurchaserResponse> {
    return this.http.post<IPurchaserResponse>(this.url, purchaser, { headers: this.headers });
  }

  updatePurchaser(purchaser: IPurchaserRequest): Observable<IPurchaserResponse> {
    const url = `${this.url}/${purchaser.id}`;
    return this.http.put<IPurchaserResponse>(url, purchaser, { headers: this.headers });
  }

  deletePurchaser(id: string) {
    const url = `${this.url}/${id}`;
    return this.http.delete<IPurchaserResponse>(url);
  }
}
